import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
//change UploadDocumentService to ExitModalService
export class UploadDocumentService {
  private pageExitModal = new Subject<boolean>();
  private pageExitConfirm = new Subject<boolean>();

  setPageExitModal(val) {
    this.pageExitModal.next(val);
  }
  getPageExitModal() {
    return this.pageExitModal.asObservable();
  }

  setPageExitConfirm(val) {
    this.pageExitConfirm.next(val);
  }
  getPageExitConfirm() {
    return this.pageExitConfirm.asObservable();
  }
}
